import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import {
  SkillTestGenerateResponse,
  SkillTestSubmitRequest,
  SkillTestResultResponse,
} from '../models/skill-learning.model';
import { SKILL_TESTS_API } from '../constants/skill-api.constants';

@Injectable()
export class SkillTestApiService {

  private readonly jsonHeaders = new Headers({ 'Content-Type': 'application/json' });
  private readonly jsonOptions = new RequestOptions({ headers: this.jsonHeaders });

  constructor(private http: Http) {}

  generateTest(specializationId: string): Observable<SkillTestGenerateResponse> {
    return this.http
      .post(SKILL_TESTS_API.GENERATE(specializationId), null, this.jsonOptions)
      .map(response => response.json() as SkillTestGenerateResponse);
  }

  submitTest(specializationId: string, request: SkillTestSubmitRequest): Observable<SkillTestResultResponse> {
    return this.http
      .post(SKILL_TESTS_API.SUBMIT(specializationId), JSON.stringify(request), this.jsonOptions)
      .map(response => response.json() as SkillTestResultResponse);
  }

  fetchTestCooldownSeconds(specializationId: string): Observable<number> {
    return this.http
      .get(SKILL_TESTS_API.COOLDOWN(specializationId))
      .map(response => response.json() as number);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/services/skill-test-api.service.ts